import { ChartData, ChatStreamEvent, ProductSuggestionData, TableData } from '../../services/chat-stream-event.model';

/** An ordered piece of an assistant reply: a run of prose, or a rendered data block. */
export type Segment =
  | { type: 'text'; text: string }
  | { type: 'table'; data: TableData }
  | { type: 'chart'; data: ChartData }
  | { type: 'product-suggestion'; data: ProductSuggestionData };

/**
 * Fold the cumulative event list into ordered segments (decision 6): consecutive `token`s coalesce
 * into one text segment; each `component` of kind `table` becomes a table segment; unknown kinds are
 * ignored. The fold is deterministic over the full list, so redoing it every tick is idempotent.
 */
export function foldSegments(events: ChatStreamEvent[]): Segment[] {
  const segments: Segment[] = [];
  for (const e of events) {
    if (e.type === 'token') {
      const last = segments.at(-1);
      if (last?.type === 'text') last.text += e.content;
      else segments.push({ type: 'text', text: e.content });
    } else if (e.type === 'component' && e.kind === 'table') {
      segments.push({ type: 'table', data: e.payload as TableData });
    } else if (e.type === 'component' && e.kind === 'chart') {
      segments.push({ type: 'chart', data: e.payload as ChartData });
    } else if (e.type === 'component' && e.kind === 'product-suggestion') {
      segments.push({ type: 'product-suggestion', data: e.payload as ProductSuggestionData });
    }
  }
  return segments;
}
